import { EmploymentNote } from './employment-note.interface';

import { EmploymentNoteService } from './employment-note.service';
const service = new EmploymentNoteService();

export interface EmploymentNoteState {
   employmentNotes: Array<EmploymentNote>;
}

const state: EmploymentNoteState = {
   employmentNotes: [],
};

const mutations = {
   SET_EMPLOYMENT_NOTES(state: EmploymentNoteState, employmentNotes: Array<EmploymentNote>) {
      state.employmentNotes = employmentNotes;
   },
   ADD_EMPLOYMENT_NOTES(state: EmploymentNoteState, newEmploymentNote: EmploymentNote) {
      state.employmentNotes = [...state.employmentNotes, newEmploymentNote];
   },
   REMOVE_EMPLOYMENT_NOTES(state: EmploymentNoteState, employmentNoteId: number) {
      state.employmentNotes = [...state.employmentNotes].filter((employmentNote) => employmentNote.id !== employmentNoteId);
   },
};

const actions = {
   async getEmploymentNotes(context: any, query: any) {
      return await service.getEmploymentNotes(query).then((employmentNotes) => {
         context.commit('SET_EMPLOYMENT_NOTES', employmentNotes.data);
         return employmentNotes.data;
      });
   },
   async addEmploymentNote(context: any, body: any) {
      return await service.postEmploymentNote(body).then((employmentNote) => {
         context.commit('ADD_EMPLOYMENT_NOTES', employmentNote);
         return employmentNote;
      });
   },
   async removeEmploymentNote(context: any, employmentNoteId: number) {
      return await service.removeEmploymentNote(employmentNoteId).then(() => {
         context.commit('REMOVE_EMPLOYMENT_NOTES', employmentNoteId);
      });
   },
};

export default {
   namespaced: true,
   state,
   mutations,
   actions,
};
